import React from 'react';

const ContactUs = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Contact Us</h2>
    <p>Have questions? Reach out to us:</p>
    <ul>
      <li>Email: support@yourdomain.com</li>
      <li>Phone: +91-9876543210</li>
      <li>Address: 123 Business Street, YourCity, India</li>
    </ul>
  </div>
);

export default ContactUs;
